export const classes = {
  card: 'group relative flex flex-col w-full rounded-2xl border bg-white dark:bg-white/[0.04] transition-colors overflow-hidden',
  cardDefault: 'border-grey-3 dark:border-white/10',
  cardSelected: 'border-brand-orange bg-orange-1/30 dark:bg-orange-3/[0.16]',
  cardInteractive: 'cursor-pointer hover:border-orange-2',
  header: 'flex items-center gap-2 px-4 pt-3 pr-10',
  label: 'min-w-0 grow',
  labelText: 'font-semibold text-sm text-grey-8 dark:text-mauve-1',
  infoPoint:
    'absolute top-2 right-3 opacity-0 group-hover:opacity-100 transition-opacity',
  body: 'flex flex-col grow px-4 pb-3 pt-2',
};
